// This file points to outer repository environment, it's for catalogue-ui compatibility.
import {environment as environmentProperties} from "../../environments/environment";


export const environment = environmentProperties;
